import * as React from 'react';

interface ILabelledProps {
  children: React.ReactNode;
}

export const Labelled = ({ children }: ILabelledProps) => <label className="labelled">{children}</label>;
